module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_5010.39f10092.png";